export default __webpack_public_path__ + "static/Maeva-1bfefe7c12ddf1a41d99232b7d3c4a75.webp";